import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles, MessageCircle } from "lucide-react";
import { fadeUp } from "@/lib/motion";
import Aurora from "@/components/landing/effects/Aurora";

const CTA = () => {
    return (
        <section
            id="cta"
            data-testid="cta-section"
            className="section py-20 md:py-24"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <motion.div
                    {...fadeUp}
                    className="relative rounded-3xl overflow-hidden glass p-10 md:p-16 text-center"
                >
                    <Aurora variant="violet" />
                    <div className="absolute inset-0 bg-grid-fine opacity-30 pointer-events-none" />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/40 pointer-events-none" />

                    <div className="relative z-10 max-w-3xl mx-auto">
                        <motion.span
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                            className="inline-flex items-center gap-2 rounded-full bg-cyan-400/10 border border-cyan-400/30 px-4 py-1.5 text-xs font-mono uppercase tracking-[0.25em] text-cyan-300"
                        >
                            <Sparkles className="h-3.5 w-3.5" />
                            Available for new projects
                        </motion.span>
                        <h2 className="mt-6 font-display font-bold text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                            Have a bold idea?
                            <br />
                            <span className="text-grad-cyan">
                                Let&apos;s ship it together.
                            </span>
                        </h2>
                        <p className="mt-5 text-zinc-300 text-lg max-w-xl mx-auto">
                            Book a 30-minute discovery call with our founders. Zero
                            obligation, full clarity on scope, timelines and pricing.
                        </p>
                        <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
                            <a
                                href="#contact"
                                data-testid="cta-primary"
                                className="btn-shine inline-flex items-center justify-center gap-2 rounded-lg bg-cyan-400 hover:bg-cyan-300 text-black font-semibold px-8 py-4 transition shadow-[0_0_40px_-10px_rgba(0,229,255,0.6)]"
                            >
                                Book a Discovery Call
                                <ArrowUpRight className="h-4 w-4" />
                            </a>
                            <a
                                href="https://wa.me/916394058460"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="cta-whatsapp"
                                className="inline-flex items-center justify-center gap-2 rounded-lg glass glass-hover border border-white/20 text-white font-medium px-8 py-4 transition"
                            >
                                <MessageCircle className="h-4 w-4" />
                                WhatsApp us instead
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default CTA;
